module.exports = __webpack_public_path__ + "static/media/ic_pa_b6_fisdom.c3359856.svg";